const instructionsItems = document.querySelectorAll(".instruction-block__item");

if (instructionsItems) {
    let neededHeight = 0;

    for (let i = 0; i < instructionsItems.length; i++) {
        if (instructionsItems[i].offsetHeight > neededHeight) {
            neededHeight = instructionsItems[i].offsetHeight;
            i++;
        }
    }

    instructionsItems.forEach((item) => {
        item.style.height = `${neededHeight}px`;
    });
}
